import { FolderInput } from "lucide-react";

export const MoveSelect = ({ profiles, current, count, onMove }) => (
  <label className="inline-flex items-center rounded-full border border-slate-300 overflow-hidden h-9 text-sm" title="Verplaats de aangevinkte leads naar een ander profiel">
    <span className="pl-3 pr-1 inline-flex items-center gap-1.5 text-slate-600">
      <FolderInput className="w-4 h-4" strokeWidth={1.5} /> Verplaats ({count}) naar
    </span>
    <select
      data-testid="batch-move-select"
      value=""
      onChange={(e) => e.target.value && onMove(e.target.value)}
      className="h-9 pl-1 pr-2 bg-white text-slate-800 outline-none cursor-pointer"
    >
      <option value="">kies…</option>
      {profiles.filter((p) => p.id !== current).map((p) => <option key={p.id} value={p.id}>{p.label}</option>)}
    </select>
  </label>
);
